export enum ConstructionDepotTypeEnum {
  Existing = 'Existing',
  Rebuild = 'Rebuild',
  New = 'New',
  Unknown = 'Unknown',
}
